// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__WeKZF","col":"styles_col__3fFt-","fulfillmentStatus":"styles_fulfillmentStatus__3KBKa","emailCol":"styles_emailCol__vM3Hq"};